import { RadioGroup, RadioGroupItem, Typography } from "@suraasa/placebo-ui"
import { Theme } from "@suraasa/placebo-ui-legacy"
import { CpatAssessmentQuestion, QuestionType } from "api/resources/cpat/types"
import clsx from "clsx"
import { createUseStyles } from "react-jss"

import shepherdClass from "../shepherdClasses"
const useStyles = createUseStyles((theme: Theme) => ({
  scroll: {
    marginBottom: 20,
    [theme.breakpoints.down("sm")]: {
      overflow: "auto",
    },
  },
  radioBox: {
    boxSizing: "border-box",
    border: `2px solid ${theme.colors.secondary[400]}`,
    borderRadius: 4,
    width: "-webkit-fill-available",
    padding: theme.spacing(1),
    maxWidth: "600px",
    cursor: "pointer",
  },
  label: {
    alignItems: "center !important",
    wordBreak: "break-word",
    whiteSpace: "pre-wrap",
  },
  selected: {
    border: `2px solid ${theme.colors.primary[500]}`,
    backgroundColor: theme.colors.primary[100],
  },
  question: {
    whiteSpace: "pre-line",
  },
  optionsContainer: {
    maxWidth: 605,
    display: "flex",
    flexDirection: "column",
    "& .Radio-root": {
      marginBottom: theme.spacing(1.5),
      "&:last-child": {
        marginBottom: 0,
      },
    },
  },
}))

const Question = ({
  question,
  handleResponse,
}: {
  question: CpatAssessmentQuestion
  handleResponse: (value: number) => void
}) => {
  const classes = useStyles()

  return (
    <div className={classes.scroll}>
      <Typography
        variant="preTitle"
        className={clsx("pb-0.5 text-onSurface-600")}
      >
        {question.question.questionType === QuestionType.SINGLE_CORRECT
          ? "Single Correct"
          : question.question.questionType === QuestionType.FILL_IN_THE_BLANKS
          ? "Fill in the Blanks"
          : "Not handled"}
      </Typography>
      <Typography variant="title3" className="pb-1.5">
        Question {question.sequence}
      </Typography>
      <Typography className={classes.question} variant="strong">
        {(question.question.text ?? "").replace("__blank__", "__________")}
      </Typography>
      <Typography
        variant="strongSmallBody"
        className="pb-1.5 pt-4 text-onSurface-500"
      >
        Options
      </Typography>

      <span
        className={clsx(
          "py-1.5",
          classes.optionsContainer,
          shepherdClass["options"]
        )}
      >
        <RadioGroup
          key={question.id}
          onValueChange={val => handleResponse(Number(val))}
        >
          {(question.question.options ?? []).map((label, value) => {
            const isSelected = question.response?.includes(value)

            return (
              <label
                key={value}
                className={clsx(
                  "flex cursor-pointer flex-row items-center gap-1 rounded-lg p-1 text-smallBody",
                  {
                    "bg-primary-100 border-2 border-primary-500": isSelected,
                    "border-2 border-secondary-400": !isSelected,
                  }
                )}
                htmlFor={label}
              >
                <RadioGroupItem
                  value={value.toString()}
                  checked={isSelected}
                  color="primary"
                  id={label}
                />
                <div>{label}</div>
              </label>
            )
          })}
        </RadioGroup>
      </span>
    </div>
  )
}

export default Question
